import React, { useState } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { Layout, Menu } from 'antd';

const { Header, Sider, Content } = Layout;

const Dashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const user = JSON.parse(localStorage.getItem('user') || 'null');
  const displayName = user?.nickname || user?.username || '管理员';

  const menuItems = [
    {
      key: 'home',
      label: '首页',
      onClick: () => navigate('/dashboard')
    },
    {
      key: 'tasks',
      label: '任务与结算审核',
      onClick: () => navigate('/dashboard/tasks')
    },
    {
      key: 'users',
      label: '用户管理',
      onClick: () => navigate('/dashboard/users')
    },
    {
      key: 'support',
      label: '客服工单',
      onClick: () => navigate('/dashboard/support')
    },
    {
      key: 'verification',
      label: '身份认证',
      onClick: () => navigate('/dashboard/verification')
    },
    {
      key: 'payments',
      label: '支付管理',
      onClick: () => navigate('/dashboard/payments')
    },
    {
      key: 'chatrooms',
      label: '聊天室管理',
      onClick: () => navigate('/dashboard/chatrooms')
    }
  ];

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login');
  };

  const selectedKey = location.pathname === '/dashboard' ? 'home' : location.pathname.split('/').pop();

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        collapsible 
        collapsed={collapsed} 
        onCollapse={setCollapsed}
        style={{
          background: 'linear-gradient(180deg, #fdfefe 0%, #f3f8ff 100%)',
          borderRight: '1px solid rgba(214, 228, 255, 0.9)',
          boxShadow: '8px 0 30px rgba(31, 42, 68, 0.05)'
        }}
      >
        <div style={{
          height: '64px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '20px',
          fontWeight: '700',
          color: '#1d4ed8',
          borderBottom: '1px solid rgba(214, 228, 255, 0.9)',
          letterSpacing: collapsed ? '0' : '0.04em'
        }}>
          {collapsed ? '百' : '百晓生'}
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
          style={{
            border: 'none'
          }}
        />
      </Sider>
      <Layout>
        <Header style={{
          height: 'auto',
          minHeight: '64px',
          lineHeight: 'normal',
          padding: '12px 24px',
          backgroundColor: 'rgba(255, 255, 255, 0.82)',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '16px',
          borderBottom: '1px solid rgba(214, 228, 255, 0.9)',
          backdropFilter: 'blur(14px)'
        }}>
          <div style={{
            fontSize: '18px',
            fontWeight: '700',
            color: '#1f2a44',
            flex: '0 0 auto'
          }}>
            管理后台
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flexWrap: 'wrap',
            gap: '12px',
            minWidth: 0,
            flex: 1
          }}>
            <div style={{
              minWidth: 0,
              flex: '1 1 180px',
              textAlign: 'right',
              overflow: 'hidden'
            }}>
              <div style={{
                fontSize: '14px',
                color: '#262626',
                fontWeight: '500',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>
                {displayName}
              </div>
              <div style={{
                fontSize: '12px',
                color: '#8C8C8C',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}>
                {user?.role || 'ADMIN'}
              </div>
            </div>
            <button
              onClick={handleLogout}
              style={{
                padding: '8px 16px',
                backgroundColor: '#F5F5F5',
                color: '#262626',
                border: 'none',
                borderRadius: '8px',
                flex: '0 0 auto',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              退出登录
            </button>
          </div>
        </Header>
        <Content style={{
          margin: '24px',
          padding: 0,
          background: 'linear-gradient(180deg, #f8fbff 0%, #edf4ff 100%)'
        }}>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default Dashboard;
